Bacon = require 'baconjs'
R = require 'ramda'
paymentsStore = require './payments'
feedbackStore = require './feedback'
resUtil = require '../utils/resources'

channel = Bacon.mergeAll paymentsStore.order, feedbackStore.order
    .map R.path ['channel', 'resource_url']
    .flatMap resUtil.loadResourceFromUrl
    .map R.prop('channel')
    .filter R.compose R.not, R.isNil
    .toProperty()

isValidUrl = (url) ->
    /^(https?:)?\/\/((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))/.test url

logo = channel
    .map R.prop 'checkout_logo'
    .toProperty()

name = channel
    .map R.prop 'name'
    .toProperty()

url = channel
    .map R.prop 'url'
    .filter isValidUrl
    .toProperty()

logo.onValue ->
name.onValue ->
url.onValue ->

module.exports = { logo, name, url }